'use strict';
var Base64 = require('../utils/base64EncodeDecode.js');
var CookieManager = require('../utils/cookieManager.js');

var TokenManager = new (function() {
  this.storageToken = '8fe8291d-50c3-4b58-9513-cb34bfbad893';
  this.getToken = function() {
    var token = CookieManager.getCookie(this.storageToken);

    if (token !== undefined && token !== null) {
      token = Base64.decode(token);
      token = JSON.parse(token);
      return token;
    } else {
      return 'You must be logged in';
    }
  };
  this.getSessionStorageToken = function() {
    return sessionStorage.getItem(this.storageToken);
  };
  this.getTokenForAuthorizationHeader = function() {
    var token = this.getToken();
    if (typeof token === 'object' && token !== null) {
      return `${token.token_type} ${token.access_token}`;
    }
    return token;
  };
  this.setToken = function(token, setLocal) {
    if (typeof token === 'object') {
      token = JSON.stringify(token);
      CookieManager.setCookieOnPhillipsDomain(this.storageToken, Base64.encode(token), setLocal);
    }
  };
  this.setSessionStorageToken = function(token) {
    sessionStorage.setItem(this.storageToken, token);
  };
  this.removeToken = function() {
    CookieManager.expireCookie(this.storageToken);
  };
  this.isTokenSet = function() {
    if (CookieManager.getCookie(this.storageToken)) {
      return true;
    }
    return false;
  };
})();
export default TokenManager;
